import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 24c0-9.942 8.057-18 18-18 9.942 0 18 8.057 18 18 0 9.942-8.057 18-18 18-9.942 0-18-8.057-18-18Zm1.8 0c0 8.948 7.252 16.2 16.2 16.2S40.2 32.948 40.2 24 32.948 7.8 24 7.8 7.8 15.052 7.8 24Zm9.264-5.664L22.727 24l-5.663 5.664c-.849.848.424 2.12 1.272 1.272L24 25.273l5.664 5.663c.848.849 2.12-.424 1.272-1.272L25.273 24l5.663-5.664c.849-.848-.424-2.121-1.272-1.272L24 22.727l-5.664-5.663c-.848-.849-2.121.424-1.272 1.272Z",
      clipRule: "evenodd"
    }
  )
);
var SvgCloseCircleOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CloseCircleOutlined_default = SvgCloseCircleOutlined;

export { CloseCircleOutlined_default as default };
